import AbsEditViewValueFormatter from "@/utils/UIConstants/AGGridEditViewValueFormatters/AbsEditViewValueFormatter.ts";
import NumberUtils from "@/utils/common/NumberUtils.ts";
import {StringUtils} from "@/utils/common/StringUtils.ts";
import NamaCommon from "@/utils/common/NamaCommon.ts";

export default class IntegerValueFormatter extends AbsEditViewValueFormatter
{
  private static _instance: IntegerValueFormatter;

  static instance() {
    if (!this._instance)
      this._instance = new IntegerValueFormatter();
    return this._instance;
  }

  format(specs: namaTypes.DTOFieldSpecs | null | undefined, value: any) {
    if (!value)
      return "";
    if (specs && specs.format)
      return NumberUtils.formatByPattern(specs, value as number);
    return value;
  }

  parse(specs: namaTypes.DTOFieldSpecs | null | undefined, value: any, oldValue?: any) {
    if (!value)
      return 0;
    value = StringUtils.replaceArNumerals(value as string)
    value = NumberUtils.removeComma(value);
    let operatorsEvaluation = NamaCommon.parseOperators(value);
    if (operatorsEvaluation)
      return parseInt(operatorsEvaluation) ?? 0;
    if (specs && specs.format)
      return NumberUtils.parseFromPattern(specs, value);
    if (isNaN(Number(value)))
      return oldValue || 0;
    return value;
  }
}
